import React, { useEffect, useRef, useState } from 'react';
import './projecttype.css';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { RadioButton } from "primereact/radiobutton";
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { ColorPicker } from 'primereact/colorpicker';
import { ConfirmDialog } from 'primereact/confirmdialog';
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Api } from '../../../services/api';
import { FaCopy, FaPencilAlt, FaTrash } from 'react-icons/fa';
import { BiPlusMedical } from 'react-icons/bi';

const Projecttype = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [projectType, setProjectType] = useState([]);
  const [searchProjectType, setSearchProjectType] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const toast = useRef(null);
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);

  // -------------------------------------------------------------
  const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);
  // -------------------------------------------------------------

  const formik = useFormik({
    initialValues: {
      name: '',
      status: 'ACTIVE',
      color_code: '',

    },
    validate: (data) => {
      let errors = {};

      if (!data.name) {
        errors.name = 'First Name is required.';
      }

      return errors;
    },
    onSubmit: (data) => {
      // Determine the URL based on the type
      let url = Api.API_BASE_URL + 'add-project-type';
      if (type === "Edit") {
        url = Api.API_BASE_URL + 'update-project-type/' + projectTypeID;
      }

      // Retrieve the token from localStorage
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };

      // Perform the fetch request with the updated headers
      fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: json.error });
          } else {
            toast.current.show({ severity: 'success', summary: 'Success', detail: json.result });
            closeModal();
            getProjectType();
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });

      console.log(data);
    }

  });
  // -------------------------------------------------------------

  const modalOverlayRef = useRef(null);
  const [selectedColorOption, setSelectedColorOption] = useState('');
  const [pageNumber, setPageNumber] = useState(0);
  const projectsPerPage = 5;
  const pagesVisited = pageNumber * projectsPerPage;
  const pageCount = Math.ceil(projectType.length / projectsPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const displayedProjects = projectType.slice(pagesVisited, pagesVisited + projectsPerPage);
  const [type, setType] = useState('Add');
  const [title, setTitle] = useState('Add Project Type');
  const [project, setProject] = useState();
  const [projectTypeID, setProjectTypeID] = useState();
  const [projectTypeName, setProjectTypeName] = useState();
  const [projectTypeStatus, setProjectTypeStatus] = useState();
  const [colorCode, setColorCode] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [globalFilter, setGlobalFilter] = useState('');

  const openModal = () => {
    setProjectTypeID('');
    formik.resetForm();
    setType('Add');
    setTitle('Add Project Type');
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsDeleteConfirmationModalOpen(false);
  };



  const editModal = (row) => {
    setProjectTypeID(row._id);
    formik.setFieldValue('name', row.name);
    formik.setFieldValue('color_code', row.color_code);
    formik.setFieldValue('status', row.status);
    setType('Edit');
    setTitle('Edit Project Type');
    setIsModalOpen(true);
  };

  const openCopyModal = (row) => {
    setProjectTypeID(row._id);
    formik.setFieldValue('name', row.name);
    formik.setFieldValue('color_code', row.color_code);
    formik.setFieldValue('status', row.status);
    setType('Add');
    setTitle('Copy Project Type');
    setIsModalOpen(true);
  };


  useEffect(() => {
    console.log('Fetching projects...xx');
    getProjectType();
  }, []);

  const getProjectType = (project) => {
    // Retrieve the token from localStorage
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Authorization': token ? `Bearer ${token}` : ''
    };

    // Make the GET request with token in the Authorization header
    axios.get(Api.API_BASE_URL + 'get-all-project-type', { headers })
      .then((response) => {
        const data = response.data.result;
        setProjectType(data);
        setSearchProjectType(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
        setIsLoading(false);
      });
  };




  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <div onClick={(e) => e.stopPropagation()}>
          <FaCopy onClick={() => openCopyModal(rowData)} style={{ marginRight: '10px', color: 'orange' }} />
          {/* <FaPencilAlt onClick={() => editModal(rowData)} style={{ marginRight: '10px' }} /> */}
          <FaTrash onClick={() => handleDeleteProject(rowData._id)} style={{ color: 'darkred' }} />
        </div>
      </React.Fragment>
    );
  };

  const handleDeleteProject = (projectId,) => {
    setProjectTypeID(projectId);
    setIsDeleteConfirmationModalOpen(true);
  };


  const confirmDelete = async () => {
    // Retrieve the token from localStorage
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Authorization': token ? `Bearer ${token}` : ''
    };

    // Make the GET request with token in the Authorization header
    try {
      const response = await axios.get(Api.API_BASE_URL + 'delete-project-type/' + projectTypeID, { headers });
      toast.current.show({
        severity: 'info',
        summary: 'Confirmed',
        detail: response.data.result,
        life: 3000
      });
      getProjectType();
      closeModal();
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };


  const showColor = (showColor) => {
    return (
      <div className="p-d-flex p-ai-center">
        <div className="p-d-block p-ml-2 p-px-3 " style={{ backgroundColor: '#' + showColor, width: "50px", height: "20px", textAlign: 'center' }}></div>
      </div>
    )

  }

  const searchrole = (searchValue) => {
    console.log('searchValue', searchValue);
    setProjectType([]);
    const searchResult = searchProjectType.filter((item) =>
      item.name.toLowerCase().includes(searchValue.toLowerCase())
    );

    setProjectType(searchResult);
    console.log(searchResult)
  }



  const header = (
    <div className="flex flex-wrap  align-items-center justify-content-between m-0 ">
      <h4 className="m-0">Manage Project Type</h4>
      <div>
        <span className="p-input-icon-left ">
          <InputText className="input-field m-1" type="search" onChange={(e) => searchrole(e.target.value)} placeholder="Search..." />
        </span>
        <button type="button" title='Add a new Project Type' style={{ cursor: 'pointer' }} onClick={openModal} className="custom-button m-2" >
          <div className='flex gap-2 px-1 py-1' style={{ alignItems: 'center' }}>
            <BiPlusMedical size={14} />
            <span> ADD </span>
          </div>
        </button>
      </div>

    </div>
  );


  const onRowSelect = (e) => {
    const rowData = e.data;
    editModal(rowData);
  };


  return (
    <>

      {/* // -------------------------------------------------------------------------------------- */}

      {/* <div style={{ textAlign: "end", padding: "10px 10px 0" }}>
        <button type="button" className="custom-button" onClick={openModal} >
          + ADD
        </button>
      </div> */}

      {/* ----------------------------------------------------------------------------------------  */}

      <div className="pagee-container mt-2">
        <Toast ref={toast} />
        <ConfirmDialog />
        <div className="pagination-datable-height">
          {isLoading ? (
            <div className="loading-spinner">
              Loading...
              <div className="spinner"></div>
            </div>
          ) : (
            <DataTable

              value={projectType}
              paginator
              rows={14}
              key="_id"
              tableStyle={{ minWidth: '50rem' }}
              selectionMode="single"
              selection={selectedProduct}
              onRowSelect={onRowSelect}
              onSelectionChange={(e) => setSelectedProduct(e.value)}
              header={header}
              globalFilter={globalFilter || ''}
              emptyMessage="No records found"
            >

              <Column body={actionBodyTemplate} header="Action" exportable={false} style={{ width: '100px', alignItems: 'center', textAlign: 'center' }}></Column>
              <Column field="name" header="Project Type" ></Column>
              <Column field="color_code" header="Color Code" style={{ alignItems: 'center', textAlign: 'center' }} body={(e) => showColor(e.color_code)}></Column>

            </DataTable>
          )}
        </div>
      </div>
      {/* ---------------------------------------------------------------*/}
      <Dialog header="" visible={isModalOpen} maximizable style={{ width: '30vw' }} dismissableMask="true" onHide={() => { setIsModalOpen(false); setSelectedProduct(null); }}>
        <div className='p-2'>
          <form onSubmit={formik.handleSubmit} className="" >
            <div className="flex-col">
              <div className="mt-2">
                <div className='card-heading'>
                  <label>Project Type</label>
                </div>
                <InputText
                  id="name"
                  name="name"
                  value={formik.values.name}
                  onChange={(e) => {
                    console.log(e.target.value);
                    formik.setFieldValue('name', e.target.value);
                  }}
                  className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('name') })} style={{ width: '100%' }}
                />
              </div>

              <div className="mt-2">
                <div className='card-heading'>
                  <label>Status</label>
                </div>
                <div>
                  <RadioButton inputId="ingredient1" name="status" value="ACTIVE" onChange={(e) => formik.setFieldValue('status', e.target.value)} checked={formik.values.status === 'ACTIVE'} />
                  <label htmlFor="ingredient1" className="ml-2">Active</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <RadioButton inputId="ingredient2" name="status" value="INACTIVE" onChange={(e) => formik.setFieldValue('status', e.target.value)} checked={formik.values.status === 'INACTIVE'} />
                  <label htmlFor="ingredient2" className="ml-2">In-Active</label>
                </div>

              </div>

              <div className="mt-4">
                <div className='card-heading'>
                  <label >Colors</label>
                </div>
                <ColorPicker id="color_code"
                  name="color_code"
                  value={formik.values.color_code}
                  onChange={(e) => {
                    console.log(e.target.value)
                    formik.setFieldValue('color_code', e.target.value);
                  }}
                  className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('color_code') })} style={{ width: '100%' }} />
              </div>
              <div className="flex  justify-content-center mt-5">
                <Button label="Submit" type="submit" className='p-2 customSave-button' />
              </div>
            </div>

          </form>

        </div>
      </Dialog>

      {/* ---------------------------------------------------------------*/}
      {isDeleteConfirmationModalOpen && (
        <div className="modal">
          <div className="small-modal-content">
            <div className="modal-headerx">
              <h5 className="modal-title">Delete Confirmation</h5>
              <button className="modal-closex" onClick={closeModal}>
                &times;
              </button>
            </div>
            <div className="modal-bodyx">
              <p>"Are you sure you want to delete this project? "</p>
            </div>
            <div className="modal-footer-cancelx">
              <button className="cancel-buttonx" onClick={closeModal}>
                Cancel
              </button>
              <button className="delete-buttonx" onClick={confirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Projecttype